const handleHrefClick = (event) => {
  event.stopPropagation();
};
export {
  handleHrefClick
};
//# sourceMappingURL=helpers.js.map
